export const SERVICE_PAGE_UI = {
    en: {
        typesSection: {
            title: "Services & Specializations",
            subtitle: "Expert marine construction for Cape Coral and Southwest Florida waterways.",
            ariaPrev: "Previous Slide",
            ariaNext: "Next Slide",
            readMore: "Service Details"
        },
        middleSection: {
            startProject: "Get Free Estimate",
            bookCall: "Call Now",
            caseStudyLabel: "Our Work",
            viewprojects: "View Recent Work"
        },
        servicesListSection: {
            headline: "Our Marine Construction Services",
            subHeadline: "From custom dock construction to boat lift installation, repair, and maintenance — we handle every aspect of your waterfront property.",
            learnMore: "Learn More",
            callNow: "Call Now",
            viewAll: "All Services"
        },
        servicesPage: {
            introTitle: "Built for Southwest Florida Waters",
            introSubtitle: "30+ years serving Cape Coral homeowners with licensed, permitted marine construction.",
            whyChooseTitle: "Why Choose Tropical Marine?",
            whyChooseText: "Florida-licensed contractor, transparent pricing, and a team that has worked every waterway in Lee and Charlotte County.",
            ctaTitle: "Ready to Start Your Waterfront Project?",
            ctaSubtitle: "From dock repairs to full boat lift installations, we're ready to help.",
            ctaText: "Serving Cape Coral, Fort Myers, Punta Gorda, and all of Southwest Florida.",
            faqTitle: "Common Questions"
        }
    },
    he: {
        typesSection: {
            title: "Services & Specializations",
            subtitle: "Expert marine construction for Cape Coral and Southwest Florida waterways.",
            ariaPrev: "Previous Slide",
            ariaNext: "Next Slide",
            readMore: "Service Details"
        },
        middleSection: {
            startProject: "Get Free Estimate",
            bookCall: "Call Now",
            caseStudyLabel: "Our Work",
            viewprojects: "View Recent Work"
        },
        servicesListSection: {
            headline: "Our Marine Construction Services",
            subHeadline: "From custom dock construction to boat lift installation, repair, and maintenance — we handle every aspect of your waterfront property.",
            learnMore: "Learn More",
            callNow: "Call Now",
            viewAll: "All Services"
        },
        servicesPage: {
            introTitle: "Built for Southwest Florida Waters",
            introSubtitle: "30+ years serving Cape Coral homeowners with licensed, permitted marine construction.",
            whyChooseTitle: "Why Choose Tropical Marine?",
            whyChooseText: "Florida-licensed contractor, transparent pricing, and a team that has worked every waterway in Lee and Charlotte County.",
            ctaTitle: "Ready to Start Your Waterfront Project?",
            ctaSubtitle: "From dock repairs to full boat lift installations, we're ready to help.",
            ctaText: "Serving Cape Coral, Fort Myers, Punta Gorda, and all of Southwest Florida.",
            faqTitle: "Common Questions"
        }
    }
};

export const getServicePageUI = (lang = 'en') => {
    return SERVICE_PAGE_UI[lang] || SERVICE_PAGE_UI['en'];
};
